import { Component, OnDestroy, OnInit} from '@angular/core';
import { ActivatedRoute, Router } from '@angular/router';
import { Flight } from '@ibe/models';
import { SidebarService } from '@ibe.components/common/sidebar/sidebar.service';
import { takeWhile } from 'rxjs/operators';
import * as moment from 'moment';
import * as fromStore from '../../../../store';
import { Store } from '@ngrx/store';
import { Observable, combineLatest, Subscription } from 'rxjs';
import * as _ from 'lodash';

import { INDRABookingService } from "@ibe.services/booking.indra.service";
import { INDRADateService } from '@ibe.services/date.indra.service';
import { INDRABFMDataStorageService } from "@ibe.services/bfm-data-storage.indra.service";
import { INDRAIbeAdminService } from "@ibe.services/ibeadmin.indra.service";
import { INDRABookingSearchService } from '@ibe.services/booking-search.indra.service';
import { INDRAANACService } from '@ibe.services/anac.indra.service';
import { INDRAFlightInfoParam, INDRABFMFlightInfoResponse } from '@ibe.models/flight-info.model.lib';
import { INDRAANACResponse, INDRAANACRequest } from '@ibe.models/atc.availability.indra.model.lib';
import { FlightEquipmentEnum } from '@ibe.components/shared/_models/enums/flight-equipment.enum';

import { AIR_LINE_CODE_TAP, 
		TRANSLATION_SIDEBAR,
		TRANSLATION_DETAILS,
		BUS_TRN_OPERATOR,
		EQUIPMENT_CODE_BUS,
		EQUIPMENT_CODE_TRAIN,
		AIRPLANE_EQUIPMENT_CODE_319,
		AIRPLANE_EQUIPMENT_CODE_320,
		AIRPLANE_EQUIPMENT_CODE_321,
		AIRPLANE_EQUIPMENT_CODE_332,
		AIRPLANE_EQUIPMENT_CODE_343,
		AIRPLANE_EQUIPMENT_CODE_AT7,
		AIRPLANE_EQUIPMENT_CODE_E90,
		AIRPLANE_EQUIPMENT_CODE_E95,
		AIRPLANE_EQUIPMENT_MODEL_319,
		AIRPLANE_EQUIPMENT_MODEL_320,
		AIRPLANE_EQUIPMENT_MODEL_321,
		AIRPLANE_EQUIPMENT_MODEL_332,
		AIRPLANE_EQUIPMENT_MODEL_343,
		AIRPLANE_EQUIPMENT_MODEL_AT7,
		AIRPLANE_EQUIPMENT_MODEL_E90,
		AIRPLANE_EQUIPMENT_MODEL_E95,
		AIRPLANE_EQUIPMENT_CODE_32N,
		AIRPLANE_EQUIPMENT_CODE_32Q,
		AIRPLANE_EQUIPMENT_CODE_339,
		AIRPLANE_EQUIPMENT_MODEL_32N,
		AIRPLANE_EQUIPMENT_MODEL_32Q,
		AIRPLANE_EQUIPMENT_MODEL_339,
		AIRPLANE_EQUIPMENT_WITH_LOGOS,
		COUNTRY_CODE_BRAZIL, 
		} from '@ibe.config';

@Component({
	selector: 'app-flight-complete-info',
	templateUrl: './flight-complete-info.indra.component.html',
	styleUrls: ['./flight-complete-info.component.scss']
})
export class INDRAFlightCompleteInfoComponent
	implements OnInit, OnDestroy {
	
	private flightIdentifier: string;
	private isAlive: boolean;
	flight: any;
	ANACInfo = [];
	airLines: string[] = [];
	currentMarket: string;
	bound;
	
	allSubscriptions: Subscription[] = [];
	anacSubscription: Subscription;
	flightSubscription: Subscription;
	flightInfoSubscription: Subscription;
	
	selectedFlight$: Observable<Flight> = this.store.select(fromStore.getSelectedFlightFromFlightResults);
	
	apiHasError: boolean = false;
	isFlightInfoLoading: boolean = true;
	hasNeoPlane: boolean = false;
	hasWifiOnBoard: boolean = false;
	neoIconName;
	mode;
	anacMonth;
	anacYear;

	constructor(
		private route: ActivatedRoute,
		private bookingService: INDRABookingService,
		private dateService: INDRADateService,
		private bfmDataStorage: INDRABFMDataStorageService,
		private ibeAdminService: INDRAIbeAdminService,
		private anacService: INDRAANACService,
		private bookingSearchService: INDRABookingSearchService,
		private sidebarService: SidebarService,
		private store: Store<fromStore.State>,
		private router: Router
	) {
		this.isAlive = true;
		
		this.flightIdentifier = this.route.snapshot.paramMap.get('flight');
		this.bound = this.route.snapshot.paramMap.get('bound');
		this.mode = this.route.snapshot.paramMap.get('mode');
		
		// subscribe to store to get selected flight during booking search flow
		this.flightSubscription = this.selectedFlight$.subscribe((flight) => { 
			if (flight) {
				this.INDRA_composeFlightForBookingSearchFlow(flight);
			}
		});
		this.allSubscriptions.push(this.flightSubscription);
	}

	ngOnInit() {
		
		// MYB or Review Flow
		if (!this.mode) {
			if (this.flightIdentifier !== 'undefined') {
				this.flight = _.cloneDeep(this.bookingService.INDRA_getBookedFlight(this.flightIdentifier));
				this.INDRA_initializeOtherFlightDetails(this.flight);
				this.INDRA_getTerminalInfo(this.flight);
			}
		} // change flow 
		else if (this.mode === 'change' && this.bound) {
			let tempFlight: any;
			if (this.bound === 'outbound') {
				tempFlight = this.bfmDataStorage.INDRA_getAtcAvailability().data.listOutbound.filter((outbound) => {
					return outbound.idFlight == +this.flightIdentifier
				});
			} else if (this.bound === 'inbound') {
				tempFlight = this.bfmDataStorage.INDRA_getAtcAvailability().data.listInbound.filter((inbound) => {
					return inbound.idFlight == +this.flightIdentifier
				});
			}
			this.flight = tempFlight[0];
			this.INDRA_initializeOtherFlightDetails(this.flight);
			this.isFlightInfoLoading = false;
		}
    }
	
	
	/** initialize flight details like airlines list, ANC info and NEO info */
	INDRA_initializeOtherFlightDetails(flight) {
		// get all operating carriers of the flight
		flight.listSegment.forEach(segment => {
			this.airLines.push(segment.operationCarrier);
		});
		
		// get ANAC info if current selected market is Brazil and first segment origin is in Brazil 
		const firstSegmentOriginCountry = flight.listSegment[0] ? this.INDRA_getLocation(flight.listSegment[0].departureAirport).countryCode : null;
		this.currentMarket = sessionStorage.getItem('market');
		if (this.currentMarket && this.currentMarket == COUNTRY_CODE_BRAZIL && firstSegmentOriginCountry == COUNTRY_CODE_BRAZIL) {
			this.INDRA_getANAC(flight);
			this.INDRA_setANACMonthYear();
		}
		
		// check if any of the planes in the trip is a NEO plane model
		this.hasNeoPlane = this.bookingSearchService.INDRA_hasNEOPlaneModel(flight);
		if (this.hasNeoPlane) {
			this.neoIconName = this.INDRA_getNeoIcon(flight);
		}
		
		// check if there is wifi onboard
		this.hasWifiOnBoard = this.INDRA_checkOnboardWifi(flight);
	}
	
	//** Complete the booking search flight object with supplementaary information from the flight info API */
	INDRA_composeFlightForBookingSearchFlow(flightParam) {
		
		let flight = _.cloneDeep(flightParam);
		this.INDRA_initializeOtherFlightDetails(flightParam);
		this.INDRA_getTerminalInfo(flight)
	}
	
	//** Get airport/bus/train terminal information from API */
	INDRA_getTerminalInfo(flight) {
		let flightInfoParam = flight.listSegment.map(
			({carrier, arrivalAirport, departureAirport, departureDate, flightNumber}) => {
            return {
                airlineCode: carrier,
                arrivalAirport: arrivalAirport,
                departureAirport: departureAirport,
                departureDate: this.dateService.INDRA_formatDate(departureDate, 'YYYY-MM-DD'),
                departureTime: this.dateService.INDRA_formatDate(departureDate, 'HH:mm:ss'),
                flightNumber: flightNumber
            }
        });
		
		this.flightInfoSubscription = 
			this.bookingSearchService.INDRA_getFlightsInfo(flightInfoParam).subscribe(
				(response: INDRABFMFlightInfoResponse) => {
				if (response && response.data && response.status === '200') {
					const flightInfoData = response.data.map(
						({departureAirport, operatingAirline, arrivalAirport, flightNumber, equipment}) => {
						return {
							departureAirportCode: departureAirport.code,
							arrivalAirportCode: arrivalAirport.code,
							airLine: operatingAirline + ' ',
							departureTerminal: departureAirport.terminal,
							arrivalTerminal: arrivalAirport.terminal,
							flightNumber: flightNumber,
							// journeyDuration: journeyDuration ? journeyDuration.toLocaleLowerCase().substring(2) : 0,
							equipment: equipment
						}
					});
					
					if (flightInfoData && flightInfoData.length > 0) {
						flightInfoData.forEach((flightInfo, i) => {
							flight.listSegment[i]['equipment'] = flightInfo.equipment; //
							// flight.listSegment[i]['duration'] = flightInfo.journeyDuration;
							flight.listSegment[i]['departureTerminal'] = flightInfo.departureTerminal;
							flight.listSegment[i]['arrivalTerminal'] = flightInfo.arrivalTerminal;
						});
					}

					this.apiHasError = false;
				} else {
					this.apiHasError = true;
				} 
				
				this.flight = flight;
				this.isFlightInfoLoading = false;
			}, err => { this.apiHasError = true; this.isFlightInfoLoading = false; this.flight = flight;});
		
		this.allSubscriptions.push(this.flightInfoSubscription);
	}
	
	
	INDRA_getLastSegmentFlight(listSegment) {
		//** Gets the last segment with equipment unequal to BUS or TRN */
		// return this.bookingService.INDRA_getLastSegmentFlightIgnoringTrain(listSegment);
		return listSegment[listSegment.length - 1];
	}
	
	
	INDRA_getFirstSegmentFlight(listSegment) {
		//** Gets the last segment with equipment unequal to BUS or TRN */
		// return this.bookingService.INDRA_getFirstSegmentFlightIgnoringTrain(listSegment);
		return listSegment[0];
	}
	
	ngOnDestroy() {
		this.isAlive = false;
		for (let sub of this.allSubscriptions) {
			if (sub) {
				sub.unsubscribe();
			}
		}
	}
	
	INDRA_getLocation(code: string) {
		if (this.mode === 'search') {
			return this.bookingSearchService.INDRA_getFlightSearchLocation(code);
		} else {
			return this.bookingService.INDRA_getLocation(code);
		}
	}
	
	INDRA_printLabel() {
		if (this.flight) {
			// return 'Total duration: ' + this.INDRA_getTotalDuration();
			return this.INDRA_getTotalDuration();
		}
	}
	
	INDRA_getTotalDuration(): String {
		const segments = this.flight.listSegment;
		let flightDuration = 0;

		// Direct flights
		if (segments.length === 1) {
			flightDuration = segments[0].duration;
		} else {
			segments.forEach(segment => {
				flightDuration += (segment.duration + (segment.stopTime > 0 && !segment.stopover ? segment.stopTime : 0));
			});
		}

		const time_diff = flightDuration;
		const minutes =
			time_diff % 60 < 10 ? '0' + (time_diff % 60) : time_diff % 60; // Overflow minutes
		const hours =
			Math.floor(time_diff / 60) === 0
				? '0' + Math.floor(time_diff / 60)
				: Math.floor(time_diff / 60);
		return hours + 'h ' + minutes + 'min';
	}

	INDRA_getDurationCommercial(stop){
		let totalMin = stop.technicalStops[0].duration;
		let hours = Math.floor(totalMin / 60);
		let min = totalMin % 60;

		return hours + "h" + min + "min";
	}
	
	INDRA_hasNoStops(): boolean {
		let hasNoStop = true;
		this.flight.listSegment.forEach(segment => {
			if (segment.stopTime > 0 && !segment.stopover) {
				hasNoStop = false;
			}
		});
		return hasNoStop;
	}
	
	INDRA_isTAPFlight(): boolean {
		let isTAP = false;
		this.flight.listSegment.forEach(segment => {
			if (segment.operationCarrier === AIR_LINE_CODE_TAP) {
				isTAP = true;
			}
		});
		return isTAP;
	}
	
	INDRA_getFlightDetails() {
		const departure = this.INDRA_getLocation(this.INDRA_getDepartureAirportIgnoringTrain());
		const arrival = this.INDRA_getLocation(this.INDRA_getArrivalAirportIgnoringTrain());
		
		let airlinesTranslationObject;
		if (this.mode === 'search') {
			airlinesTranslationObject = this.bfmDataStorage.INDRA_getBookingAvailability().translate.airlines;
		} else {
			airlinesTranslationObject = this.bfmDataStorage.activeBooking.translate.airlines;
		}
		
		return {details: this.flight, departureLocation: departure, arrivalLocation: arrival, airLinesTranslation: airlinesTranslationObject};
	}
	
	INDRA_getArrivalAirport() {
		const flightsLength = this.flight.listSegment.length;
		return this.flight.listSegment[flightsLength - 1].arrivalAirport;
	}
	
	INDRA_getArrivalAirportIgnoringTrain() {
		// return this.bookingService.INDRA_getLastSegmentFlightIgnoringTrain(this.flight.listSegment)['arrivalAirport'];
		return this.flight.listSegment[this.flight.listSegment.length - 1]['arrivalAirport'];
	}

	INDRA_getDepartureAirportIgnoringTrain() {
		// return this.bookingService.INDRA_getFirstSegmentFlightIgnoringTrain(this.flight.listSegment)['departureAirport'];
		return this.flight.listSegment[0]['departureAirport'];
	}
	
	INDRA_printDatetime(time: string): string {
		return this.dateService.INDRA_formatDate(time, 'ddd DD MMMM — HH:mm');
	}


	INDRA_hasTerminal(terminal: string, i: number, segmentDivision: number): boolean {
		const segment = this.flight.listSegment[i];
		const listSegmentLength = this.flight.listSegment.length;
		switch (segmentDivision) {
			case 0:
				switch (segment.equipment) {
					case EQUIPMENT_CODE_BUS:
						return true;
					case EQUIPMENT_CODE_TRAIN:
						return true;
					default:
						if (terminal) {
							return true;
						} else return false;

				}
			case 1:
				switch (segment.equipment) {
					case EQUIPMENT_CODE_BUS:
						if (this.flight.listSegment[i + 1].equipment === EQUIPMENT_CODE_BUS || 
							this.flight.listSegment[i + 1].equipment === EQUIPMENT_CODE_TRAIN) {
							return true;
						} else {
							return true;
						}
					case EQUIPMENT_CODE_TRAIN:
						if (this.flight.listSegment[i + 1].equipment === EQUIPMENT_CODE_TRAIN || 
							this.flight.listSegment[i + 1].equipment === EQUIPMENT_CODE_BUS) {
							return true;
						} else {
							return true;
						}
					default:
						if (terminal) {
							return true;
						} else return false;
				}
			case 2:
				switch (this.flight.listSegment[i + 1].equipment) {
					case EQUIPMENT_CODE_BUS:
						if (this.flight.listSegment[i].equipment === EQUIPMENT_CODE_BUS || 
							this.flight.listSegment[i].equipment === EQUIPMENT_CODE_TRAIN) {
							return true;
						} else {
							return true;
						}
					case EQUIPMENT_CODE_TRAIN:
						if (this.flight.listSegment[i].equipment === EQUIPMENT_CODE_TRAIN || 
							this.flight.listSegment[i].equipment === EQUIPMENT_CODE_BUS) {
							return true;
						} else {
							return true;
						}
					default:
						if (terminal) {
							return true;
						} else return false;
				}
		}
	}


	INDRA_getEquipmentTypeTranslation(terminal: string, i: number, segmentDivision: number) {
		const segment = this.flight.listSegment[i];
		const listSegmentLength = this.flight.listSegment.length;
		const busStationTranslationKey = this.INDRA_getTextTranslation('busStation');
		const trainStationTranslationKey = this.INDRA_getTextTranslation('trainStation');
		const airportTranslationKey = this.INDRA_getTextTranslation('airport');
		const terminalTranslationKey = this.INDRA_getTextTranslation('terminal');
		switch (segmentDivision) {
			case 0:
				switch (segment.equipment) {
					case EQUIPMENT_CODE_BUS:
						if (segment.busStop) {
							return 'busStops.label.' + segment.busStop.ibeAdminKey.replace('KEY_', '').replace('_', '');
						} else {
							return;
						}
					case EQUIPMENT_CODE_TRAIN:
						return trainStationTranslationKey;
					default:
						return terminalTranslationKey;
				}
			case 1:
				switch (segment.equipment) {
					case EQUIPMENT_CODE_BUS:
						if (this.flight.listSegment[i + 1].equipment === EQUIPMENT_CODE_BUS || 
							this.flight.listSegment[i + 1].equipment === EQUIPMENT_CODE_TRAIN) {
							return busStationTranslationKey;
						} else {
							return airportTranslationKey;
						}
					case EQUIPMENT_CODE_TRAIN:
						if (this.flight.listSegment[i + 1].equipment === EQUIPMENT_CODE_TRAIN || 
							this.flight.listSegment[i + 1].equipment === EQUIPMENT_CODE_BUS) {
							return trainStationTranslationKey;
						} else {
							return airportTranslationKey;
						}
					default:
						return terminalTranslationKey;
				}
			case 2:
				switch (this.flight.listSegment[i + 1].equipment) {
					case EQUIPMENT_CODE_BUS:
						/*
						if (this.flight.listSegment[i].equipment === EQUIPMENT_CODE_BUS || 
							this.flight.listSegment[i].equipment === EQUIPMENT_CODE_TRAIN) {
							return busStationTranslationKey;
						} else {
							return airportTranslationKey;
							return busStationTranslationKey;
						}
						*/
						return busStationTranslationKey;
					case EQUIPMENT_CODE_TRAIN:
						/*
						if (this.flight.listSegment[i].equipment === EQUIPMENT_CODE_TRAIN || 
							this.flight.listSegment[i].equipment === EQUIPMENT_CODE_BUS) {
							return trainStationTranslationKey;
						} else {
							return airportTranslationKey;
						}
						*/
						return trainStationTranslationKey;
					default:
						return terminalTranslationKey;
				}
		}
	}
	
	
	INDRA_getTerminal(terminal: string, i: number, segmentDivision: number): string {
		const segment = this.flight.listSegment[i];
		const listSegmentLength = this.flight.listSegment.length;
		switch (segmentDivision) {
			case 0: switch (segment.equipment) {
				case EQUIPMENT_CODE_BUS: return this.INDRA_getTextTranslation('busStation');
				case EQUIPMENT_CODE_TRAIN: return;
				default: 
					if (!terminal) {
						terminal = '';
					}
					return  ` ${terminal} `;
			}
			case 1: switch (segment.equipment) {
				case EQUIPMENT_CODE_BUS: 
					if (this.flight.listSegment[i + 1].equipment === EQUIPMENT_CODE_BUS || 
						this.flight.listSegment[i + 1].equipment === EQUIPMENT_CODE_TRAIN) {
						return;
					} else {
						return;
					}
				case EQUIPMENT_CODE_TRAIN: 
					if (this.flight.listSegment[i + 1].equipment === EQUIPMENT_CODE_TRAIN ||
						this.flight.listSegment[i + 1].equipment === EQUIPMENT_CODE_BUS) {
						return;
					} else {
						return;
					}
				default: 
					if (!terminal) {
						terminal = '';
					}
					return ` ${terminal} `;
			}
			case 2: switch (this.flight.listSegment[i + 1].equipment) {
				case EQUIPMENT_CODE_BUS: 
					if (this.flight.listSegment[i].equipment === EQUIPMENT_CODE_BUS || 
						this.flight.listSegment[i].equipment === EQUIPMENT_CODE_TRAIN) {
						return;
					} else {
						return;
					}
				case EQUIPMENT_CODE_TRAIN: 
					if (this.flight.listSegment[i].equipment === EQUIPMENT_CODE_TRAIN || 
						this.flight.listSegment[i].equipment === EQUIPMENT_CODE_BUS) {
						return;
					} else {
						return;
					}
				default: 
					if (!terminal) {
						terminal = '';
					}
					return  ` ${terminal} ` ;
			}
		}
	}
	
	INDRA_isLongLayover(flightIndex: number) {
		let flag = false;
		// long layover flag is updated to the segment that ends the layover
		const nextSegment = this.flight.listSegment[flightIndex + 1];
		if (nextSegment && nextSegment.longLayover) {
			flag = true;
		}
		return flag;
	}
	
	INDRA_getLayoverDuration(index: number) {
		const stopTime = this.flight.listSegment[index].stopTime;
		const hourNum = Math.floor(stopTime / 60);
		const minNum = stopTime % 60;
		const hour = hourNum < 10 ? '0' + hourNum : hourNum;
		const min = minNum < 10 ? '0' + minNum : minNum;
		let string = '';
		if (hour > 0) {
			string += hour + 'h ';
		}

		string += min + 'min';
		return string;
	}
	
	
	INDRA_isStopFlight(flightIndex: number) {
		let flag = false;
		const segment = this.flight.listSegment[flightIndex];
		if (segment.stopTime > 0 && !segment.stopover) {
			flag = true;
		}
		return flag;
	}
	
	INDRA_showAirportChangeWarning(flightIndex: number) {
		let flag = false;
		const segment = this.flight.listSegment[flightIndex];
		const nextSegment = this.flight.listSegment[flightIndex+1];
		if (nextSegment && nextSegment.departureAirport !== segment.arrivalAirport) {
			flag = true;
		}
		return flag;
	}
	
	INDRA_getChangeTranslation(flightIndex: number) {
		if (this.INDRA_isStopFlight(flightIndex)) {
			const segment = this.flight.listSegment[flightIndex + 1];
			switch (segment.equipment) {
				case EQUIPMENT_CODE_BUS: 
					if (this.flight.listSegment[flightIndex].equipment !== EQUIPMENT_CODE_BUS) {
						return 'changeToBus';
					} else {
						return 'changeBus';
					}
				case EQUIPMENT_CODE_TRAIN: 
					if (this.flight.listSegment[flightIndex].equipment !== EQUIPMENT_CODE_TRAIN) {
						return 'changeToTrain';
					} else {
						return 'changeTrain';
					}
				default: 
					if (this.flight.listSegment[flightIndex].equipment === EQUIPMENT_CODE_TRAIN || 
						this.flight.listSegment[flightIndex].equipment === EQUIPMENT_CODE_BUS) {
						return 'changeToPlanes';
					} else {
						return 'changePlanes';
					}
			}
		}
	}
	
	INDRA_getArrivalTerminal() {
		const flightsLength = this.flight.listSegment.length;
		const segment = this.flight.listSegment[flightsLength - 1];
		if (segment.arrivalTerminal) {
			switch (segment.equipment) {
				case EQUIPMENT_CODE_BUS: return;
				case EQUIPMENT_CODE_TRAIN: return;
				default: return segment.arrivalTerminal;
			}
		} else {
			switch (segment.equipment) {
				case EQUIPMENT_CODE_BUS: return this.INDRA_getTextTranslation('busStation');
				case EQUIPMENT_CODE_TRAIN: return;
				default: return;
			}
		}
	}
	
	INDRA_getArrivalEquipmentTypeTranslation(){
		const flightsLength = this.flight.listSegment.length;
		const segment = this.flight.listSegment[flightsLength - 1];
		const busStationTranslationKey = this.INDRA_getTextTranslation('busStation');
		const trainStationTranslationKey = this.INDRA_getTextTranslation('trainStation');
		const terminalTranslationKey = this.INDRA_getTextTranslation('terminal');
		if (segment.arrivalTerminal) {
			switch (segment.equipment) {
				case EQUIPMENT_CODE_BUS: return busStationTranslationKey;
				case EQUIPMENT_CODE_TRAIN: return trainStationTranslationKey;
				default: return terminalTranslationKey;
			}
		} else {
			switch (segment.equipment) {
				case EQUIPMENT_CODE_BUS: 
					if (segment.busStop) {
						return 'busStops.label.' + segment.busStop.ibeAdminKey.replace('KEY_', '').replace('_', '');
					} else {
						return;
					}
				case EQUIPMENT_CODE_TRAIN: return trainStationTranslationKey;
				default: return terminalTranslationKey;
			}
		}
	}
	
	INDRA_hasArrivalTerminal() {
		const flightsLength = this.flight.listSegment.length;
		const segment = this.flight.listSegment[flightsLength - 1];
		if (segment.arrivalTerminal) {
			switch (segment.equipment) {
				case EQUIPMENT_CODE_BUS: return true;
				case EQUIPMENT_CODE_TRAIN: return true;
				default: return true;
			}
		} else {
			switch (segment.equipment) {
				case EQUIPMENT_CODE_BUS: return true;
				case EQUIPMENT_CODE_TRAIN: return true;
				default: return false;
			}
		}
	}
	
	INDRA_getArrivalTime() {
		const flightsLength = this.flight.listSegment.length;
		return this.flight.listSegment[flightsLength - 1].arrivalDate;
	}
	
	INDRA_getDuration(flightIndex: number): String {
		if (this.INDRA_hasNoStops()) {
			return this.INDRA_getTotalDuration();
		} else {
			const stopTime = this.flight.listSegment[flightIndex].duration;
			const hourNum = Math.floor(stopTime / 60);
			const minNum = stopTime % 60;
			const hour = hourNum < 10 ? '0' + hourNum : hourNum;
			const min = minNum < 10 ? '0' + minNum : minNum;
			let string = '';
			if (hour > 0) {
				string += hour + 'h ';
			}

			string += min + 'min';
			return string;
		}
	}
	
	INDRA_getAirplaneName(code) {
		let airplaneName;
		if (this.mode === 'search') {
			airplaneName = this.bookingSearchService.INDRA_getFlightSearchAirplaneInfo(code).name;
		} else {
			airplaneName = this.bookingService.INDRA_getAirplaneInfo(code).name;
		}
		return airplaneName ? airplaneName : code;
	}
	
	INDRA_isNonPlaneEquipment(segment) {
		return (segment.equipment === EQUIPMENT_CODE_BUS || segment.equipment === EQUIPMENT_CODE_TRAIN);
	}
	
	INDRA_getBusTrnOperator(segment) {
		if (segment.equipment === EQUIPMENT_CODE_BUS || segment.equipment === EQUIPMENT_CODE_TRAIN) {
			return BUS_TRN_OPERATOR;
		} else {
			return '';
		}
	}
	
	INDRA_getAirplaneModel(equipment: string) {
		const key = 'bookingDetails.sidebars.details.label.' + equipment;
		const translation = this.INDRA_getTranslation(key);
		if (key === translation) {
			return equipment;
		} else {
			return translation;
		}
	}
	
	INDRA_getTranslation(key: string): string {
		return this.ibeAdminService.getTranslationValue(key);
	}
	
	INDRA_getTextTranslation(lastKey: string, type = 'texts') {
		const key = `bookingDetails.${TRANSLATION_SIDEBAR}${TRANSLATION_DETAILS}${type}.${lastKey}`;
		return key;
	}
	
	INDRA_getANAC(flight) {

		let ANACsegments = flight.listSegment.map(segment => {
			return {
				from: segment.departureAirport,
				to: segment.arrivalAirport,
				departureCountry: this.INDRA_getLocation(segment.departureAirport).countryCode,
				arrivalCountry: this.INDRA_getLocation(segment.arrivalAirport).countryCode,
				operationCarrier: segment.operationCarrier
			}
		})
		for (let { from, to, departureCountry, arrivalCountry, operationCarrier } of ANACsegments) {
			if ((departureCountry == COUNTRY_CODE_BRAZIL || arrivalCountry == COUNTRY_CODE_BRAZIL) && operationCarrier == AIR_LINE_CODE_TAP) {
				this.anacSubscription = this.anacService.INDRA_ANAC({ from, to }).subscribe((ANAC: INDRAANACResponse) => {
					this.ANACInfo.push({ from, to, ...ANAC.data });
				});
			}
		}
		this.allSubscriptions.push(this.anacSubscription);
	}
	
	INDRA_setANACMonthYear() {
		const currentDate = moment().subtract(2, 'months').format('MMMM YYYY').toLowerCase(); // temporary solution (subtract 2 months)
		const splittedDateArray = currentDate.split(' ');
		this.anacYear = splittedDateArray[1];
		this.anacMonth = splittedDateArray[0];
	}
	
	INDRA_getPlaneImage() {
		let equipment = '';
		let imgPrefix = 'assets/images/planes/';
		let imgFormat = '.jpg';
		this.flight.listSegment.forEach(segment => {
			if (segment.equipment) {
				equipment = segment.equipment;
			}
		});
		switch (equipment) {
			case AIRPLANE_EQUIPMENT_CODE_319:
				return imgPrefix + AIRPLANE_EQUIPMENT_MODEL_319 + imgFormat;
			case AIRPLANE_EQUIPMENT_CODE_320:
				return imgPrefix + AIRPLANE_EQUIPMENT_MODEL_320 + imgFormat;
			case AIRPLANE_EQUIPMENT_CODE_321:
				return imgPrefix + AIRPLANE_EQUIPMENT_MODEL_321 + imgFormat;
			case AIRPLANE_EQUIPMENT_CODE_332:
				return imgPrefix + AIRPLANE_EQUIPMENT_MODEL_332 + imgFormat;
			case AIRPLANE_EQUIPMENT_CODE_343:
				return imgPrefix + AIRPLANE_EQUIPMENT_MODEL_343 + imgFormat;
			case AIRPLANE_EQUIPMENT_CODE_AT7:
				return imgPrefix + AIRPLANE_EQUIPMENT_MODEL_AT7 + imgFormat;
			case AIRPLANE_EQUIPMENT_CODE_E90:
				return imgPrefix + AIRPLANE_EQUIPMENT_MODEL_E90 + imgFormat;
			case AIRPLANE_EQUIPMENT_CODE_E95:
				return imgPrefix + AIRPLANE_EQUIPMENT_MODEL_E95 + imgFormat;
			case AIRPLANE_EQUIPMENT_CODE_32N:
				return imgPrefix + AIRPLANE_EQUIPMENT_MODEL_32N + imgFormat;
			case AIRPLANE_EQUIPMENT_CODE_32Q:
				return imgPrefix + AIRPLANE_EQUIPMENT_MODEL_32Q + imgFormat;
			case AIRPLANE_EQUIPMENT_CODE_339:
				return imgPrefix + AIRPLANE_EQUIPMENT_MODEL_339 + imgFormat;
			default:
				return '';
		}
	}
	
	/** Handles close action intention **/
	INDRA_handleClose() {
		this.sidebarService.closeSidebar();
		this.router.navigate([{ outlets: { sidebar: null } }], { replaceUrl: true });
	}
	
	INDRA_hasNeoPlane() {
		return this.hasNeoPlane;
	}
	
	INDRA_getNeoIcon(flight) {
		let neoPlaneIconName = '';
        if (flight && flight.listSegment) {
			const significantFlightSegment = this.bookingSearchService.INDRA_getTAPMostSignificantFlightSegment(flight);
			if (significantFlightSegment) {
				if (AIRPLANE_EQUIPMENT_WITH_LOGOS.includes(significantFlightSegment.equipment)) {
					neoPlaneIconName = this.bookingSearchService.INDRA_getNEOEquipmentLogoName(
						significantFlightSegment.equipment, significantFlightSegment.haul);
				}
			}
        }
		return neoPlaneIconName;
    }
	
	INDRA_checkOnboardWifi(flight) {
        if (flight && flight.listSegment) {
			const significantFlightSegment = this.bookingSearchService.INDRA_getTAPMostSignificantFlightSegment(flight);
			if (significantFlightSegment) {
				const { equipment, duration } = significantFlightSegment;
				return FlightEquipmentEnum.isWifiOnBoard(equipment) && !this.getAirplaneStyleDescription(equipment, duration, 'A321neo');
			}
        }
		return false;
    }
	
	private getAirplaneStyleDescription(equipment: any, duration: any, description: string) {
		if (equipment && duration) {
			const hours = Math.floor(duration / 60);
			const planeStyleDescription = FlightEquipmentEnum.getAirplaneStyleDescription(equipment, hours);
			return planeStyleDescription === description;
		}
		return false;
	}
	
	INDRA_neoIconName() {
		return this.neoIconName;
	}
	
	INDRA_showInfo(index) {
        // return this.INDRA_getCompanyName(index).indexOf('TAP') > -1 && this.arrivalAirportCode === 'MCZ';
		return false;
	}
	
	INDRA_hasTechnicalStop(segment): boolean {
		let flag = false;
		if (segment.technicalStops && segment.technicalStops.length > 0) {
			flag = true; 
		}
		return flag;
    }
	
	INDRA_getTechnicalStop(segment) {
		let stopName;
		if (segment.technicalStops && segment.technicalStops.length > 0) {
			const locationCode = segment.technicalStops[0].location; 
				stopName = this.bookingSearchService.INDRA_getFlightSearchLocation(locationCode);
		}
		return stopName;
	}
}
